<template>
  <div>
    Loading ...
  </div>
</template>

<script>
export default {
  name: 'Loading',
};
</script>



// WEBPACK FOOTER //
// src/components/Loading.vue